/* Shipping choice in the bag - see snippets/zc-shipping-choice.liquid.
   A pick stamps every line of that shipment with the hidden property _zc_ship,
   which the carrier service reads to hand checkout the one chosen rate. */
(function () {
  if (window.__zcsBound) return;
  window.__zcsBound = true;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* Hila, 2026-11-03: most shoppers never click a row, because Standard already shows
     as selected, so their lines carried no _zc_ship and checkout listed every option.
     Stamp what the bag shows as selected onto any line that has no choice yet, with no
     reload, so checkout always gets the one rate the bag shows. */
  var stamping = false, again = false;
  function autoStamp() {
    var groups = document.querySelectorAll('[data-zcs] [data-zcs-group]');
    if (!groups.length) return;
    if (stamping) { again = true; return; }
    var wantByLine = {};
    groups.forEach(function (g) {
      var sel = g.querySelector('input[type=radio]:checked');
      var want = sel ? sel.value : 'std';
      (g.getAttribute('data-lines') || '').split(',').filter(Boolean).forEach(function (n) { wantByLine[n] = want; });
    });
    stamping = true;
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(async function (cart) {
      var jobs = Object.keys(wantByLine).map(function (n) {
        var it = cart.items[Number(n) - 1];
        return it && !(it.properties || {})._zc_ship ? { key: it.key, want: wantByLine[n] } : null;
      }).filter(Boolean);
      for (var j = 0; j < jobs.length; j++) {
        var pos = cart.items.findIndex(function (it) { return it.key === jobs[j].key; });
        if (pos < 0) continue;
        var it = cart.items[pos];
        var props = Object.assign({}, it.properties || {});
        if (props._zc_ship) continue;
        props._zc_ship = jobs[j].want;
        cart = await post('cart/change.js', { line: pos + 1, quantity: it.quantity, properties: props });
      }
    }).catch(function () {}).then(function () {
      stamping = false;
      if (again) { again = false; autoStamp(); }
    });
  }
  var timer = null;
  function soon() { clearTimeout(timer); timer = setTimeout(autoStamp, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soon); else soon();
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var k = 0; k < added.length; k++) {
        var n = added[k];
        if (n.nodeType === 1 && (n.matches('[data-zcs]') || n.querySelector('[data-zcs]'))) { soon(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('change', function (e) {
    var input = e.target && e.target.closest && e.target.closest('[data-zcs] input[type=radio]');
    if (!input) return;
    var box = input.closest('[data-zcs]');
    var ship = input.closest('[data-zcs-group]');
    var want = input.value;
    ship.querySelectorAll('.zcs-opt').forEach(function (l) { l.classList.toggle('is-sel', l.contains(input)); });
    var idx = (ship.getAttribute('data-lines') || '').split(',').filter(Boolean).map(Number);
    box.setAttribute('aria-busy', 'true');

    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(async function (cart) {
      /* line numbers shift if Shopify merges lines, so resolve each target by the
         key it had before any change, against the latest cart */
      var keys = idx.map(function (n) { return cart.items[n - 1] && cart.items[n - 1].key; }).filter(Boolean);
      for (var k = 0; k < keys.length; k++) {
        var pos = cart.items.findIndex(function (it) { return it.key === keys[k]; });
        if (pos < 0) continue;
        var it = cart.items[pos];
        var props = Object.assign({}, it.properties || {});
        if (props._zc_ship === want) continue;
        props._zc_ship = want;
        cart = await post('cart/change.js', { line: pos + 1, quantity: it.quantity, properties: props });
      }
    }).catch(function () {}).then(function () {
      if (box.closest('[data-cart-drawer]') && window.ZTHEME && window.ZTHEME.refreshCart) {
        return window.ZTHEME.refreshCart();
      }
      window.location.reload();
    });
  });
})();
